import { render, staticRenderFns } from "./mancrealFlowReportList.vue?vue&type=template&id=60b0496f"
import script from "./mancrealFlowReportList.vue?vue&type=script&lang=js"
export * from "./mancrealFlowReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports